<template>
  <v-row>
    <v-col v-if="objectDetails">
      <div class="attribute-item-row">
        <div
          v-for="attribute in attributes"
          :key="attribute.attributeKey"
          class="attribute-item py-3"
        >
          <div class="attribute-item-title">
            {{ attribute.displayName }}
          </div>
          <div class="attribute-item-value mt-3">
            {{ attribute.formatter?attribute.formatter(objectDetails[attribute.attributeKey]):objectDetails[attribute.attributeKey] }}
          </div>
        </div>
      </div>
    </v-col>
    <v-col
      v-else
      class="text-center my-10"
    >
      {{ local.common.noData }}
    </v-col>
  </v-row>
</template>
<script>

export default {
  name: 'NajDataRow',
  components: {},
  props: {
    objectDetails: {
      type: Object,
      def: true,
      required: true,
      default: () => ({}),
    },
    attributes: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

.attribute-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #158e8d;
}

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: #02363d;
}
</style>

